export default {
  modalsById: {},
  modalsIds: []
};
